/**
 * The Organization Settings tabs and which permission shows each one.
 *
 * `OrganizationSettings.vue` shows only the tabs the user may see and steers a user who
 * lands on another one (including the bare `/settings` index, which redirects to Steks) to
 * the first visible tab. The order here is the landing order.
 */

/**
 * ``view`` shows a tab, ``manage`` enables its mutations (see the backend's
 * ``UserPermissions``): user managers see Billing read-only, organisation managers see
 * Users read-only.
 */
export interface SettingsPermissions {
    can_manage_steks?: boolean;
    can_view_users?: boolean;
    can_manage_users?: boolean;
    can_view_billing?: boolean;
    can_manage_billing?: boolean;
}

export interface SettingsTabDef {
    value: string;
    label: string;
    routeName: string;
    permission: keyof SettingsPermissions;
}

export const SETTINGS_TABS: readonly SettingsTabDef[] = [
    {
        value: "steks",
        label: "Steks",
        routeName: "stekManagement",
        permission: "can_manage_steks",
    },
    {
        value: "users",
        label: "Users",
        routeName: "userManagement",
        permission: "can_view_users",
    },
    {
        value: "billing",
        label: "Billing & Subscription",
        routeName: "organizationBilling",
        permission: "can_view_billing",
    },
];

export const visibleSettingsTabs = (
    perms: SettingsPermissions | null | undefined
): SettingsTabDef[] =>
    perms ? SETTINGS_TABS.filter((tab) => perms[tab.permission] === true) : [];
